// extracted by mini-css-extract-plugin
export default {"msgM":"_59af9e951c"};